import Vue from "vue"

Vue.use((Vue) => {
    // Assign a unique id to each component
    let uuid = 0;
    Vue.mixin({
        beforeCreate: function () {
            this.uuid = uuid.toString();
            uuid += 1;
        },
    });

    // Generate a component-scoped id
    Vue.prototype.$id = function (id) {
        return "uid-" + this.uuid + "-" + id;
    };
});
